import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="page-inside">
    <Helmet>
      <title>Page Not Found | TravelCarma</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="container py-5 text-center" style={{ maxWidth: 760 }}>
      <h1 className="fw-bold mb-3">Page Not Found</h1>
      <p className="text-secondary mb-4">
        The page you are looking for may have moved or no longer exists.
      </p>
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        <Link to="/" className="btn btn-primary">
          Go to Homepage
        </Link>
        <Link to="/contact-us" className="btn btn-outline-primary">
          Contact TravelCarma
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
